import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, BookOpen, CheckCircle } from 'lucide-react';
import './style/ChooseFromBook.css'

const bookData = [
  {
    id: 1,
    title: "Chapter 1: Introduction to React",
    topics: [
      { id: 1, title: "What is React?" },
      { id: 2, title: "Setting up a React project" },
      { id: 3, title: "Understanding JSX" },
      { id: 4, title: "Components and Props" },
      { id: 5, title: "State and Lifecycle" },
    ]
  },
  {
    id: 2,
    title: "Chapter 2: Advanced React Concepts",
    topics: [
      { id: 6, title: "Hooks Overview" },
      { id: 7, title: "useEffect Hook" },
      { id: 8, title: "Context API" },
      { id: 9, title: "React Router" },
      { id: 10, title: "Error Boundaries" },
    ]
  },
  {
    id: 3,
    title: "Chapter 3: State Management",
    topics: [
      { id: 11, title: "Introduction to Redux" },
      { id: 12, title: "Actions and Reducers" },
      { id: 13, title: "Redux Middleware" },
      { id: 14, title: "Redux Toolkit" },
      { id: 15, title: "Alternative State Management" },
    ]
  },
  {
    id: 4,
    title: "Chapter 4: Testing and Deployment",
    topics: [
      { id: 16, title: "Unit Testing with Jest" },
      { id: 17, title: "Integration Testing" },
      { id: 18, title: "End-to-End Testing" },
      { id: 19, title: "Optimizing Performance" },
      { id: 20, title: "Deploying React Applications" },
    ]
  }
];

export default function ChooseFromBook() {
  const [expandedChapters, setExpandedChapters] = useState({});
  const [selectedTopics, setSelectedTopics] = useState({});
  const [animateIn, setAnimateIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimateIn(true);
  }, []);

  const toggleChapter = (chapterId) => {
    setExpandedChapters(prev => ({
      ...prev,
      [chapterId]: !prev[chapterId]
    }));
  };

  const toggleTopic = (topicId) => {
    setSelectedTopics(prev => ({
      ...prev,
      [topicId]: !prev[topicId]
    }));
  };

  const handleCreateAssignment = () => {
    const selectedTopicIds = Object.keys(selectedTopics).filter(id => selectedTopics[id]);
    navigate(`/assignments/assignment-summary`, { state: { selectedTopicIds } });
  };

  const selectedTopicsCount = Object.values(selectedTopics).filter(Boolean).length;

  return (
    <div className='assignment-info bg-gradient-to-br from-blue-50 to-indigo-100'>
    <div className={`unique9-choose-from-book-container ${animateIn ? 'animate-in' : ''}`}>
      <div className="unique9-background-decoration"></div>
      <h1 className="unique9-title">
        <BookOpen className="unique9-title-icon" />
        React Fundamentals
      </h1>
      <div className="unique9-book-content">
        {bookData.map((chapter) => (
          <div key={chapter.id} className="unique9-chapter">
            <div 
              className="unique9-chapter-header" 
              onClick={() => toggleChapter(chapter.id)}
            >
              <h2>{chapter.title}</h2>
              {expandedChapters[chapter.id] ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </div>
            {expandedChapters[chapter.id] && (
              <div className="unique9-topics">
                {chapter.topics.map((topic) => (
                  <div key={topic.id} className="unique9-topic">
                    <label className="unique9-topic-label">
                      <input
                        type="checkbox"
                        checked={selectedTopics[topic.id] || false}
                        onChange={() => toggleTopic(topic.id)}
                        className="unique9-topic-checkbox"
                      />
                      <div className="unique9-topic-info">
                        <h3>{topic.title}</h3>
                      </div>
                      {selectedTopics[topic.id] && (
                        <CheckCircle className="unique9-check-icon" size={20} />
                      )}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <button 
        className="unique9-create-assignment-btn"
        onClick={handleCreateAssignment}
        disabled={selectedTopicsCount === 0}
      >
        Create Assignment ({selectedTopicsCount} topics selected)
      </button>
    </div>
    </div>
  );
}